import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["loader"]

  showLoader() {
    // Hide navigation buttons
    const buttons = this.element.querySelectorAll('a[data-turbo-stream]')
    buttons.forEach(button => {
      button.style.display = 'none'
    })

    // Show loader
    if (this.hasLoaderTarget) {
      this.loaderTarget.classList.remove('hidden')
    }
  }

  hideLoader() {
    // Show navigation buttons again
    const buttons = this.element.querySelectorAll('a[data-turbo-stream]')
    buttons.forEach(button => {
      button.style.display = 'flex'
    })

    // Hide loader
    if (this.hasLoaderTarget) {
      this.loaderTarget.classList.add('hidden')
    }
  }
}